"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";
import type { NavItem } from "./eventNavConfig";

interface SidebarNavItemProps {
  item: NavItem;
}

export function SidebarNavItem({ item }: SidebarNavItemProps) {
  const pathname = usePathname();
  const isActive =
    pathname === item.href || pathname.startsWith(`${item.href}/`);

  const Icon = item.icon;

  return (
    <SidebarMenuItem className="list-none">
      <SidebarMenuButton
        asChild
        isActive={isActive}
        size="default"
        className={cn(
          "relative h-10 rounded-lg p-2 gap-1",
          isActive
            ? "bg-primary-50 hover:bg-primary-50 text-primary-600"
            : "text-text-secondary hover:bg-neutral-50 hover:text-neutral-900",
        )}
      >
        <Link href={item.href}>
          {Icon && (
            <Icon
              className={cn(
                "shrink-0 size-5",
                isActive ? "text-primary-600" : "text-text-secondary",
              )}
            />
          )}
          <span
            className={cn(
              "paragraph-sm group-data-[collapsible=icon]:hidden pl-1",
              isActive ? "text-primary-600" : "text-text-secondary",
            )}
          >
            {item.label}
          </span>
          {isActive && (
            <span className="nav-active-indicator pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-0.75 h-4 rounded-full group-data-[collapsible=icon]:hidden" />
          )}
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}
